import { useQuery } from "urql";

import {
  GetWaivesDocument,
  WaiveFilter,
  WaiveOrderBy,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

export function useWaive({
  filter,
  orderBy,
  pause,
  page,
}: ApiHookProps<WaiveFilter, WaiveOrderBy>) {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({
    query: GetWaivesDocument,
    variables,
    pause,
  });
}
